import { Schema } from "effect";
import {
  ChannelThreadId,
  MessageId,
  SupportTicketId,
} from "../../ids/definitions";

export const AiReasoningNotification = Schema.Struct({
  _tag: Schema.Literal("aiReasoning"),
  supportTicketId: SupportTicketId,
  threadId: ChannelThreadId,
  text: Schema.String,
});
export type AiReasoningNotification = typeof AiReasoningNotification.Type;

export const AiToolCallNotification = Schema.Struct({
  _tag: Schema.Literal("aiToolCall"),
  supportTicketId: SupportTicketId,
  threadId: ChannelThreadId,
  toolName: Schema.String,
  toolCallId: Schema.String,
});
export type AiToolCallNotification = typeof AiToolCallNotification.Type;

export const AiTextDeltaNotification = Schema.Struct({
  _tag: Schema.Literal("aiTextDelta"),
  supportTicketId: SupportTicketId,
  threadId: ChannelThreadId,
  textDelta: Schema.String,
});
export type AiTextDeltaNotification = typeof AiTextDeltaNotification.Type;

export const AiStatusNotification = Schema.Struct({
  _tag: Schema.Literal("aiStatus"),
  supportTicketId: SupportTicketId,
  threadId: ChannelThreadId,
  status: Schema.String,
});
export type AiStatusNotification = typeof AiStatusNotification.Type;

export const AiMessageAddedNotification = Schema.Struct({
  _tag: Schema.Literal("aiMessageAdded"),
  supportTicketId: SupportTicketId,
  threadId: ChannelThreadId,
  messageId: MessageId,
  contentType: Schema.String,
});
export type AiMessageAddedNotification = typeof AiMessageAddedNotification.Type;

export const AiActivityNotification = Schema.Union(
  AiReasoningNotification,
  AiToolCallNotification,
  AiTextDeltaNotification,
  AiStatusNotification,
  AiMessageAddedNotification,
);
export type AiActivityNotification = typeof AiActivityNotification.Type;

export type AiActivityNotificationTag = AiActivityNotification["_tag"];
